import { Capacitor } from '@capacitor/core';

export interface NativeVoipPermissionResult {
  notification: NotificationPermission | 'unsupported';
  microphone: boolean;
}

interface RequestNativeVoipPermissionsOptions {
  prompt?: boolean;
}

export async function requestNativeVoipPermissions(options: RequestNativeVoipPermissionsOptions = {}): Promise<NativeVoipPermissionResult> {
  const result: NativeVoipPermissionResult = {
    notification: 'unsupported',
    microphone: false,
  };

  const { prompt = false } = options;

  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'android') {
    return result;
  }

  const notificationApi = typeof window !== 'undefined' ? window.Notification : globalThis.Notification;
  if (notificationApi) {
    if (!prompt) {
      result.notification = notificationApi.permission;
    } else if (notificationApi.permission === 'default') {
      result.notification = await notificationApi.requestPermission();
    } else {
      result.notification = notificationApi.permission;
    }
  }

  try {
    if (prompt) {
      const { CapacitorTwilioVoice } = await import('@capgo/capacitor-twilio-voice');
      const micResult = await CapacitorTwilioVoice.requestMicrophonePermission();
      result.microphone = Boolean(micResult?.granted);
    }
  } catch (error) {
    console.error('[VoIP Permissions] Failed to request microphone permission:', error);
  }

  console.log('[VoIP Permissions] Android permission request completed', result);
  return result;
}
